import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { usePurchaseRequestSelectSearch } from '@/hooks/usePurchaseRequestSelectSearch';
import type { PurchaseRequestResponse } from '@/api/procurement.api';

export interface PurchaseRequestSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onRequestChange?: (request: PurchaseRequestResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  name?: string;
  /** When true, only APPROVED purchase requests are listed */
  approvedOnly?: boolean;
}

export function PurchaseRequestSelect({
  label = 'Purchase request',
  value = '',
  onChange,
  onRequestChange,
  placeholder = 'Select purchase request (optional)',
  disabled,
  className,
  required,
  error,
  name,
  approvedOnly,
}: PurchaseRequestSelectProps) {
  const { options, loading, searching, onSearchQuery, getPurchaseRequest } = usePurchaseRequestSelectSearch({
    value,
    requestStatus: approvedOnly ? 'APPROVED' : undefined,
  });

  const handleChange = (next: string) => {
    onChange?.(next);
    onRequestChange?.(next ? getPurchaseRequest(next) ?? null : null);
  };

  return (
    <SearchableSelect
      label={label}
      name={name}
      required={required}
      error={error}
      value={value}
      onChange={handleChange}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      loading={loading}
      searching={searching}
      className={className}
      searchPlaceholder="Search by request number…"
      emptyMessage="No purchase requests found"
      filterLocally={false}
      onSearchQuery={onSearchQuery}
    />
  );
}
